import { render, staticRenderFns } from "./CertificateBar.vue?vue&type=template&id=09252aa9&scoped=true"
import script from "./CertificateBar.vue?vue&type=script&lang=js"
export * from "./CertificateBar.vue?vue&type=script&lang=js"
import style0 from "./CertificateBar.vue?vue&type=style&index=0&id=09252aa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09252aa9",
  null
  
)

export default component.exports